import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    // {
    //     key: 'admin-login',
    //     path: `${AUTH_PREFIX_PATH}/admin-login`,
    //     component: React.lazy(() => import('views/auth-views/authentication/admin-login')),
    // },
    // {
    //     key: 'register',
    //     path: `${AUTH_PREFIX_PATH}/register`,
    //     component: React.lazy(() => import('views/auth-views/authentication/register')),
    // },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    },
    {
        key: 'reset-password',
        path: `${AUTH_PREFIX_PATH}/reset-password`,
        component: React.lazy(() => import('views/auth-views/authentication/reset-password')),
    }
]

export const protectedRoutes = [
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/dashboards/default')),
    },
    {
        key: 'dashboard.analytic',
        path: `${APP_PREFIX_PATH}/dashboards/analytic`,
        component: React.lazy(() => import('views/app-views/dashboards/analytic')),
    },
    {
        key: 'users.list',
        path: `${APP_PREFIX_PATH}/users/list`,
        component: React.lazy(() => import('views/app-views/users/list')),
    },
    {
        key: 'users.paid-members',
        path: `${APP_PREFIX_PATH}/users/paid-members`,
        component: React.lazy(() => import('views/app-views/users/paid-members')),
    },
    {
        key: 'users.paid-member-view',
        path: `${APP_PREFIX_PATH}/users/paid-members/:id`,
        component: React.lazy(() => import('views/app-views/users/paid-members/view')),
    },
    {
        key: 'users.view',
        path: `${APP_PREFIX_PATH}/users/view/:id`,
        component: React.lazy(() => import('views/app-views/users/view')),
    },
    {
        key: 'users.edit',
        path: `${APP_PREFIX_PATH}/users/edit/:id`,
        component: React.lazy(() => import('views/app-views/users/edit')),
    },
    {
        key: 'pages.setting',
        path: `${APP_PREFIX_PATH}/pages/setting/*`,
        component: React.lazy(() => import('views/app-views/pages/setting')),
    },
    {
        key: 'pages.transcriptionStyles',
        path: `${APP_PREFIX_PATH}/pages/transcription-styles`,
        component: React.lazy(() => import('views/app-views/pages/transcription-styles')),
    },
    {
        key: 'pages.taglines',
        path: `${APP_PREFIX_PATH}/pages/taglines`,
        component: React.lazy(() => import('views/app-views/pages/taglines')),
    },
    {
        key: 'pages.notificationTypes',
        path: `${APP_PREFIX_PATH}/pages/notification-types`,
        component: React.lazy(() => import('views/app-views/pages/notification-types')),
    },
    {
        key: 'pages.trendyData',
        path: `${APP_PREFIX_PATH}/pages/trendy-data`,
        component: React.lazy(() => import('views/app-views/pages/trendy-data')),
    },
    {
        key: 'stories.list',
        path: `${APP_PREFIX_PATH}/stories/list`,
        component: React.lazy(() => import('views/app-views/stories/list')),
    },
    {
        key: 'plans.list',
        path: `${APP_PREFIX_PATH}/plans/list`,
        component: React.lazy(() => import('views/app-views/plans/list')),
    },
    {
        key: 'plans.create',
        path: `${APP_PREFIX_PATH}/plans/create`,
        component: React.lazy(() => import('views/app-views/plans/form')),
    },
    {
        key: 'plans.edit',
        path: `${APP_PREFIX_PATH}/plans/edit/:id`,
        component: React.lazy(() => import('views/app-views/plans/form')),
    },
    {
        key: 'credits.list',
        path: `${APP_PREFIX_PATH}/credits/list`,
        component: React.lazy(() => import('views/app-views/credits/list')),
    },
    {
        key: 'credits.create',
        path: `${APP_PREFIX_PATH}/credits/create`,
        component: React.lazy(() => import('views/app-views/credits/form')),
    },
    {
        key: 'credits.edit',
        path: `${APP_PREFIX_PATH}/credits/edit/:id`,
        component: React.lazy(() => import('views/app-views/credits/form')),
    },
    {
        key: 'credit-amount.list',
        path: `${APP_PREFIX_PATH}/credit-amount/list`,
        component: React.lazy(() => import('views/app-views/credit-amount/list')),
    },
    {
        key: 'credit-amount.create',
        path: `${APP_PREFIX_PATH}/credit-amount/create`,
        component: React.lazy(() => import('views/app-views/credit-amount/form')),
    },
    {
        key: 'credit-amount.edit',
        path: `${APP_PREFIX_PATH}/credit-amount/edit/:id`,
        component: React.lazy(() => import('views/app-views/credit-amount/form')),
    },
    {
        key: 'prompts.list',
        path: `${APP_PREFIX_PATH}/prompts/list`,
        component: React.lazy(() => import('views/app-views/prompts/list')),
    },
    {
        key: 'prompts.create',
        path: `${APP_PREFIX_PATH}/prompts/create`,
        component: React.lazy(() => import('views/app-views/prompts/create')),
    },
    {
        key: 'popular-styles.list',
        path: `${APP_PREFIX_PATH}/popular-styles/list`,
        component: React.lazy(() => import('views/app-views/popular-styles')),
    },
    {
        key: 'community-images.list',
        path: `${APP_PREFIX_PATH}/community-images/list`,
        component: React.lazy(() => import('views/app-views/community-images/list')),
    },
    {
        key: 'architect-images.list',
        path: `${APP_PREFIX_PATH}/architect-images/list`,
        component: React.lazy(() => import('views/app-views/architect-images/list')),
    },
    {
        key: 'sfx.list',
        path: `${APP_PREFIX_PATH}/sfx/list`,
        component: React.lazy(() => import('views/app-views/sfx/list')),
    },
    {
        key: 'videos.list',
        path: `${APP_PREFIX_PATH}/videos/list`,
        component: React.lazy(() => import('views/app-views/videos/list')),
    },
    {
        key: 'music.list',
        path: `${APP_PREFIX_PATH}/music/list`,
        component: React.lazy(() => import('views/app-views/music/list')),
    },
    {
        key: 'lipsync-styles.list',
        path: `${APP_PREFIX_PATH}/lipsync-styles/list`,
        component: React.lazy(() => import('views/app-views/lipsync-styles')),
    },
    {
        key: 'music-styles.list',
        path: `${APP_PREFIX_PATH}/music-styles/list`,
        component: React.lazy(() => import('views/app-views/music-styles')),
    },
    {
        key: 'recast-library.characters.list',
        path: `${APP_PREFIX_PATH}/recast-library/characters`,
        component: React.lazy(() => import('views/app-views/recast-library/characters/list')),
    },
    {
        key: 'recast-library.backgrounds.list',
        path: `${APP_PREFIX_PATH}/recast-library/backgrounds`,
        component: React.lazy(() => import('views/app-views/recast-library/backgrounds/list')),
    },
    {
        key: 'stories.view',
        path: `${APP_PREFIX_PATH}/stories/view/:id`,
        component: React.lazy(() => import('views/app-views/stories/view')),
    },
]